/**
 * Runtime configuration helper.
 *
 * Per-env values come from `public/runtime-config.<EnvName>.js`, which the
 * WSC frontend pipeline template copies onto `runtime-config.js` at deploy
 * time. The script tag in `index.html` loads it before the main bundle so
 * `window.config` is populated by the time this module runs.
 *
 * Build-time `.env.production` values still serve as fallbacks (used for
 * local dev, prod builds where runtime-config wasn't swapped, etc.).
 */

const runtime = (typeof window !== 'undefined' && window.config) || {}

export const config = {
  apiUrl: runtime.apiUrl ?? import.meta.env.VITE_API_URL ?? '',
  cdnUrl: runtime.cdnUrl ?? import.meta.env.VITE_CDN_URL ?? 'https://d2mmslqgf5c9ia.cloudfront.net',
  wsUrl:  runtime.wsUrl  ?? import.meta.env.VITE_WS_URL  ?? '',
  // Origin of the hosted MCP OAuth authorization server (the API exposing
  // /authorize + /mcp-oauth/session). Only needed when it differs from apiUrl
  // (e.g. local ngrok tunnel, or a dedicated MCP host in prod). Falls back to
  // apiUrl. Used to trust the OAuth returnUrl + session-bridge target.
  mcpUrl: runtime.mcpUrl ?? import.meta.env.VITE_MCP_URL ?? '',
}
